var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchnormal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1673 20.1673L18.334 18.334M10.5423 19.2507C11.6859 19.2507 12.8183 19.0254 13.8749 18.5878C14.9314 18.1501 15.8914 17.5087 16.7 16.7C17.5087 15.8914 18.1501 14.9314 18.5878 13.8749C19.0254 12.8183 19.2507 11.6859 19.2507 10.5423C19.2507 9.39872 19.0254 8.26633 18.5878 7.20978C18.1501 6.15324 17.5087 5.19324 16.7 4.3846C15.8914 3.57595 14.9314 2.9345 13.8749 2.49687C12.8183 2.05923 11.6859 1.83398 10.5423 1.83398C8.23272 1.83398 6.01773 2.75147 4.3846 4.3846C2.75147 6.01773 1.83398 8.23272 1.83398 10.5423C1.83398 12.8519 2.75147 15.0669 4.3846 16.7C6.01773 18.3332 8.23272 19.2507 10.5423 19.2507Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchnormal);
export default __webpack_public_path__ + "static/media/searchnormal.c300323b3623955b42f5e4f8e9e57da0.svg";
export { ForwardRef as ReactComponent };